import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { Table } from 'primeng/table';
import { ConversaoLibraConverte } from '../../../shared/conversao-libra/conversao-libra-converte';
import { ExportExcelService } from '../../../shared/excel-service/export-excel.service';
import { FiltroService } from '../../../shared/filtro/filtro.service';
import { DealerItem } from '../../../shared/filtro-dealers/filtro-dealers.component';
import { FiltroDealers } from './filtro-dealer';
import { VeiculosPedidosFiltroService } from './veiculos-pedidos-filtro.service';
import { VeiculosPedidosService } from './veiculos-pedidos.service';
import { ServiceAppService } from '../../../security/service-app.service';

export interface ICadastro {
  numeroPedido: String;
  chassi: String;
  idPedido: number;
}

@Component({
  selector: 'app-veiculos-pedidos',
  templateUrl: './veiculos-pedidos.component.html',
  styleUrls: ['./veiculos-pedidos.component.scss']
})

export class VeiculosPedidosComponent implements OnInit {
  @Input() filtros: any;

  form: FormGroup;
  subscription: any;
  display: boolean = false
  submitted: boolean = false
  dadosCadastro: ICadastro = {
    numeroPedido: '',
    chassi: '',
    idPedido: 0
  };
  statusAtendimentoOptions = [
    { label: 'Atendido', value: 'SIM' },
    { label: 'Não Atendido', value: 'NAO' },
    { label: 'Faturado', value: 'FATURADO' },
    { label: 'Cancelado', value: 'CANCELADO' }
  ];

  tipoPedidoOptions: any[] = [];

  selecionado: object;
  selecionados = [];
  gruposEconomicos = [];

  cols: any[];
  _selectedColumns: any[];
  dados: any[] = [];

  first: number = 0;
  displayRows: number = 0;
  rows: number = 10;
  totalRecords: number = 0;

  loading: boolean = false;
  displayFiltros: boolean = false;
  displayFiltrosDealers: boolean = false;

  nomeModulo: string;
  dataInicial: Date;
  dataFinal: Date;

  filtrosDealers: FiltroDealers;
  cargaTela: boolean;

  @ViewChild('dt') dt: Table;

  dadosTranslate = {
    "Dealer": "relatorioVeiculos.controlePedidos.gridHeader.dealer",
    "Chassi": "relatorioVeiculos.controlePedidos.gridHeader.chassi",
    "Nº Pedido Dealer": "relatorioVeiculos.controlePedidos.gridHeader.numeroPedidoDealer",
    "Nº Pedido Fábrica": "relatorioVeiculos.controlePedidos.gridHeader.numeroPedidoFabrica",
    "Numero Nota Fabrica": "relatorioVeiculos.controlePedidos.gridHeader.numeroNotaFabrica",
    "Modelo": "relatorioVeiculos.controlePedidos.gridHeader.modelo",
    "Preço de Venda": "relatorioVeiculos.controlePedidos.gridHeader.precoVenda",
    "Cor Externa": "relatorioVeiculos.controlePedidos.gridHeader.corExterna",
    "Cor Interna": "relatorioVeiculos.controlePedidos.gridHeader.corInterna",
    "Ano/Modelo": "relatorioVeiculos.controlePedidos.gridHeader.anoModelo",
    "nome do Vendedor": "relatorioVeiculos.controlePedidos.gridHeader.nomeVendedor",
    "Data do Pedido": "relatorioVeiculos.controlePedidos.gridHeader.dataPedido",
    "CPF": "relatorioVeiculos.controlePedidos.gridHeader.cpfCliente",
    "Nome Cliente": "relatorioVeiculos.controlePedidos.gridHeader.nomeCliente",
    "Telefone Cliente": "relatorioVeiculos.controlePedidos.gridHeader.telefoneCliente",
    "Número da Proposta": "relatorioVeiculos.controlePedidos.gridHeader.numeroProposta",
    "Tipo do Pedido": "relatorioVeiculos.controlePedidos.gridHeader.tipoPedido",
  }

  constructor(private service: VeiculosPedidosService,
    private translate: TranslateService,
    private conversaoLibraConverte: ConversaoLibraConverte,
    private servico: VeiculosPedidosFiltroService,
    private veiculosPropostas: FiltroService,
    private serviceApp: ServiceAppService,
    private exportExcelSerivce: ExportExcelService,
    private fb: FormBuilder) {
    this.filtros = {};
    this.nomeModulo = 'Controle de Pedidos';
    this.filtrosDealers = new FiltroDealers(this.servico);
    this.tratarData();

    this.form = this.fb.group({
      data_inicial: [moment(this.dataInicial).format('DD-MM-YYYY')],
      data_final: [moment(this.dataFinal).format('DD-MM-YYYY')],
      dealers: [''],
      grupo_economico: [''],
      tipoPedido: [''],
      chassi: [''],
      numeroPedidoDealer: [''],
      numeroPedidoFabrica: [''],
      status: ['']
    });
  }

  ngOnInit() {
    this.cargaTela = true;
    this.changeLanguageValue();
    this.preencherTipoPedidoOptions();
    this.preencherGruposEconomicos();

    this.loading = true;

    this.cols = [
      { field: 'edit', header: 'Status', headerBr: 'Status', headerGb: 'Status', width: '130px' },
      { field: 'nome', header: 'relatorioVeiculos.controlePedidos.gridHeader.dealer', headerBr: 'Dealer', headerGb: 'Dealer', width: '350px' },
      { field: 'chassi', header: 'relatorioVeiculos.controlePedidos.gridHeader.chassi', headerBr: 'Chassi', headerGb: 'Chassis', width: '140px' },
      { field: 'numeroPedidoDealer', header: 'relatorioVeiculos.controlePedidos.gridHeader.numeroPedidoDealer', headerBr: 'Nº Pedido Dealer', headerGb: 'Dealer Order No.', width: '190px' },
      { field: 'numeroPedido', header: 'relatorioVeiculos.controlePedidos.gridHeader.numeroPedidoFabrica', headerBr: 'Nº Pedido Fábrica', headerGb: 'Factory Order No.', width: '190px' },
      { field: 'numeroNotaFabrica', header: 'relatorioVeiculos.controlePedidos.gridHeader.numeroNotaFabrica', headerBr: 'Numero Nota Fabrica', headerGb: 'Factory Invoice No.', width: '190px' },
      { field: 'modelo', header: 'relatorioVeiculos.controlePedidos.gridHeader.modelo', headerBr: 'Modelo', headerGb: 'Model', width: '300px' },
      { field: 'valorVenda', header: 'relatorioVeiculos.controlePedidos.gridHeader.precoVenda', headerBr: 'Preço de Venda', headerGb: 'Sale Price', width: '140px' },
      { field: 'corExterna', header: 'relatorioVeiculos.controlePedidos.gridHeader.corExterna', headerBr: 'Cor Externa', headerGb: 'External Color', width: '140px' },
      { field: 'corInterna', header: 'relatorioVeiculos.controlePedidos.gridHeader.corInterna', headerBr: 'Cor Interna', headerGb: 'Internal Color', width: '170px' },
      { field: 'anoModelo', header: 'relatorioVeiculos.controlePedidos.gridHeader.anoModelo', headerBr: 'Ano/Modelo', headerGb: 'Year/Model', width: '140px' },
      { field: 'nomeVendedor', header: 'relatorioVeiculos.controlePedidos.gridHeader.nomeVendedor', headerBr: 'Nome do Vendedor', headerGb: 'Seller Name', width: '250px' },
      { field: 'dataPedido', header: 'relatorioVeiculos.controlePedidos.gridHeader.dataPedido', headerBr: 'Data do Pedido', headerGb: 'Request Date', width: '140px' },
      { field: 'cpfCliente', header: 'relatorioVeiculos.controlePedidos.gridHeader.cpfCliente', headerBr: 'CPF', headerGb: 'SSN', width: '140px' },
      { field: 'nomeCliente', header: 'relatorioVeiculos.controlePedidos.gridHeader.nomeCliente', headerBr: 'Nome Cliente', headerGb: 'Client Name', width: '140px' },
      { field: 'telefoneCliente', header: 'relatorioVeiculos.controlePedidos.gridHeader.telefoneCliente', headerBr: 'Telefone Cliente', headerGb: 'Client Phone', width: '160px' },
      { field: 'numeroProposta', header: 'relatorioVeiculos.controlePedidos.gridHeader.numeroProposta', headerBr: 'Número da Proposta', headerGb: 'Proposal Number', width: '190px' },
      { field: 'tipoPedido', header: 'relatorioVeiculos.controlePedidos.gridHeader.tipoPedido', headerBr: 'Tipo do Pedido', headerGb: 'Order Type', width: '180px' }
    ];

    this._selectedColumns = this.cols;

    this.filtrosDealers.carregar();
    this.getAll();
  }

  @Input() get selectedColumns(): any[] {
    return this._selectedColumns;
  }

  set selectedColumns(val: any[]) {
    //restore original order
    this._selectedColumns = this.cols.filter(col => val.includes(col));
  }

  get f() { return this.form.controls; }

  private preencherGruposEconomicos() {
    this.veiculosPropostas.buscar('grupo_economico')
      .then(r => { this.gruposEconomicos = r.filtros; });
  }

  private getAll() {
    this.service.getDados(this.f.data_inicial.value, this.f.data_final.value, this.f.dealers.value, this.f.grupo_economico.value,
      this.f.chassi.value, this.f.numeroPedidoDealer.value, this.f.numeroPedidoFabrica.value, this.f.status.value, this.f.tipoPedido.value).subscribe(dados => {
        this.dados = dados.dealers;

        this.dados.forEach(element => {
          this.normalizarDadosCliente(element);

          const atual = this.conversaoLibraConverte.conversaoLibra(element.valorVenda, null, null);
          const valorFormatado = Intl.NumberFormat('pt-br', { style: 'currency', currency: 'BRL' }).format(atual);
          element.valorVenda = valorFormatado.replace("R$", "");

          if (element.dataPedido) {
        
            const dataOriginal = element.dataPedido.substring(0, 10);
            const dataObj = new Date(dataOriginal);
            const dataFormatada = moment(dataObj).format("DD/MM/YYYY");
            
  
            element.dataPedido = {
              valueOf: () => dataObj.getTime(), 
              toString: () => dataFormatada     
            };
          } else {
            element.dataPedido = {
              valueOf: () => 0,  
              toString: () => " - "
            };
          }
        });

        this.loading = false;
        this.cargaTela = false;
      });
  }

  private tratarData() {
    const dataInicio = new Date();
    const dataFim = new Date();

    let firstDay = new Date(dataInicio.getFullYear(), dataInicio.getMonth(), 1);

    this.dataInicial = firstDay;
    this.dataFinal = dataFim;
  }

  public filtroAPI() {
    this.loading = true;
    this.displayFiltros = false;

    this.f.data_inicial.setValue(moment(this.dataInicial).format('DD-MM-YYYY'));
    this.f.data_final.setValue(moment(this.dataFinal).format('DD-MM-YYYY'));

    this.filtrosSelecionados();
    this.getAll();
  }

  private filtrosSelecionados() {
    const dealers = [];

    this.incluirFiltroDealers(dealers);

    this.filtros.dealers = dealers.map(r => r.valor);

    if (this.filtros.dealers.length != 0) {
      this.f.dealers.setValue(this.filtros.dealers[0]);
    } else {
      this.f.dealers.setValue('');
    }
  }

  public getListagemComFiltros(): boolean {
    return this.dataInicial
      || this.dataFinal
      || this.f.grupo_economico.value
      || this.f.dealer.value
      || this.f.tipoPedido.value
      || this.f.chassi.value
      || this.f.numeroPedidoDealer.value
      || this.f.numeroPedidoFabrica.value
  }

  public selecionarDealer() {
    this.displayFiltrosDealers = true;
  }

  public removerDealer(dealer: any) {
    dealer.selecionado = false;
    const index = this.filtros.dealers;
    if (index > -1) {
      this.filtros.dealers.splice(index, dealer);
      this.filtrosSelecionados();
    }
  }

  public onAdicionarDealerFiltro(dealer: DealerItem) {
    dealer.selecionado = true;
    const sel = [];

    this.incluirFiltroDealers(sel);
    this.filtros.dealers = sel;
  }

  public exibirFiltro() {
    this.displayFiltros = true;
  }

  private incluirFiltroDealers(filtros: any[]) {
    if (this.filtrosDealers.selecionados().length > 0) {
      const item = { 'chave': 'dealers', 'valor': [] };
      this.filtrosDealers.selecionados().forEach(element => {
        item.valor.push(element.id);
      });
      filtros.push(item);
    }
  }

  public limparFiltros() {
    this.f.grupo_economico.setValue('');
    this.f.chassi.setValue('');
    this.f.numeroPedidoDealer.setValue('');
    this.f.numeroPedidoFabrica.setValue('');
    this.f.status.setValue('');
    this.f.tipoPedido.setValue('');
  }

  public limpaDataInicial() {
    const dataInicio = new Date();
    this.dataInicial = new Date(dataInicio.getUTCFullYear(), dataInicio.getMonth(), 1);
  }

  public limpaDataFinal() {
    const dataFim = new Date();
    this.dataFinal = new Date(dataFim.getFullYear(), dataFim.getMonth(), dataFim.getDate());
  }

  protected getTranslate(value) {
    if (value.status == 'Vendido') {
      return this.translate.currentLang == "br" ? value.status = "Vendido" : value.status = "Sold";
    }

    return this.dadosTranslate[value];
  }

  private translateHeader(item) {
    if (item == "Status") {
      return "Status";
    }
    if (item == "relatorioVeiculos.controlePedidos.gridHeader.dealer") {
      return "Dealer";
    }
    if (item == "relatorioVeiculos.controlePedidos.gridHeader.chassi") {
      return this.translate.currentLang == "br" ? "Chassi" : "Chassis";
    }
    if (item == "relatorioVeiculos.controlePedidos.gridHeader.numeroPedidoDealer") {
      return this.translate.currentLang == "br" ? "Nº Pedido Dealer" : "Dealer Order No.";
    }
    if (item == "relatorioVeiculos.controlePedidos.gridHeader.numeroPedidoFabrica") {
      return this.translate.currentLang == "br" ? "Nº Pedido Fábrica" : "Factory Order No.";
    }
    if (item == "relatorioVeiculos.controlePedidos.gridHeader.numeroNotaFabrica") {
      return this.translate.currentLang == "br" ? "Numero Nota Fabrica" : "Factory Invoice No.";
    }
    if (item == "relatorioVeiculos.controlePedidos.gridHeader.modelo") {
      return this.translate.currentLang == "br" ? "Modelo" : "Model";
    }
    if (item == "relatorioVeiculos.controlePedidos.gridHeader.precoVenda") {
      return this.translate.currentLang == "br" ? "Preço de Venda" : "Sale Price";
    }
    if (item == "relatorioVeiculos.controlePedidos.gridHeader.corExterna") {
      return this.translate.currentLang == "br" ? "Cor Externa" : "External Color";
    }
    if (item == "relatorioVeiculos.controlePedidos.gridHeader.corInterna") {
      return this.translate.currentLang == "br" ? "Cor Interna" : "Internal Color";
    }
    if (item == "relatorioVeiculos.controlePedidos.gridHeader.anoModelo") {
      return this.translate.currentLang == "br" ? "Ano/Modelo" : "Year/Model";
    }
    if (item == "relatorioVeiculos.controlePedidos.gridHeader.nomeVendedor") {
      return this.translate.currentLang == "br" ? "Nome do Vendedor" : "Seller Name";
    }
    if (item == "relatorioVeiculos.controlePedidos.gridHeader.dataPedido") {
      return this.translate.currentLang == "br" ? "Data do Pedido" : "Request Date";
    }
    if (item == "relatorioVeiculos.controlePedidos.gridHeader.cpfCliente") {
      return this.translate.currentLang == "br" ? "CPF" : "SSN";
    }
    if (item == "relatorioVeiculos.controlePedidos.gridHeader.nomeCliente") {
      return this.translate.currentLang == "br" ? "Nome Cliente" : "Client Name";
    }
    if (item == "relatorioVeiculos.controlePedidos.gridHeader.telefoneCliente") {
      return this.translate.currentLang == "br" ? "Telefone Cliente" : "Client Phone";
    }
    if (item == "relatorioVeiculos.controlePedidos.gridHeader.numeroProposta") {
      return this.translate.currentLang == "br" ? "Número da Proposta" : "Proposal Number";
    }
    if (item == "relatorioVeiculos.controlePedidos.gridHeader.tipoPedido") {
      return this.translate.currentLang == "br" ? "Tipo do Pedido" : "Order Type";
    }
  }

  private getExportColumns(): any[] {
    return this.cols.filter(col => col.field !== 'edit').concat([
      { field: 'status', headerBr: 'Status', headerGb: 'Status' }
    ]);
  }

  public getStatusButtonClass(status: string): string {
    switch ((status || '').trim()) {
      case 'Atendido':
        return 'p-button-sm p-button-success';
      case 'Faturado':
        return 'p-button-sm p-button-info';
      case 'Cancelado':
        return 'p-button-sm p-button-danger';
      case 'Não Atendido':
      default:
        return 'p-button-sm';
    }
  }

  public isCadastroPedidoFabricaBloqueado(dados: any): boolean {
    const status = (dados?.status || '').trim();
    return status === 'Faturado' || status === 'Cancelado';
  }

  private getExportColumnLabel(col: any): string {
    return this.translate.currentLang === 'gb' ? col.headerGb : col.headerBr;
  }

  private normalizarDadosCliente(registro: any): void {
    const cliente = registro?.cliente;

    if (cliente && typeof cliente === 'object') {
      registro.nomeCliente = registro.nomeCliente || cliente.nome || cliente.nomeCliente || '';
      registro.cpfCliente = registro.cpfCliente ?? cliente.cpf ?? cliente.cpfCnpj ?? cliente.documento ?? '';
      registro.telefoneCliente = registro.telefoneCliente || cliente.telefone || cliente.telefoneCliente || '';
    }

    registro.nomeCliente = registro.nomeCliente || registro.NomeCliente || registro.clienteNome || registro.nome_cliente || '';
    registro.cpfCliente = registro.cpfCliente ?? registro.CpfCliente ?? registro.cpf ?? registro.documento ?? registro.cpfCnpj ?? registro.cpf_cnpj ?? '';
    registro.telefoneCliente = registro.telefoneCliente || registro.TelefoneCliente || registro.telefone || registro.fone || '';
  }

  private formatarCpfCnpj(valor: any): string {
    if (valor == null || valor === '') {
      return '';
    }

    const numeros = String(valor).replace(/\D/g, '');
    if (!numeros) {
      return '';
    }

    if (numeros.length <= 11) {
      const cpf = ('00000000000' + numeros).slice(-11);
      return cpf.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    }

    const cnpj = ('00000000000000' + numeros).slice(-14);
    return cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
  }

  private formatTipoPedido(value: any): string {
    if (value == null || value === '') {
      return '';
    }

    const option = this.tipoPedidoOptions.find(o => o.value === Number(value));
    return option ? option.label : String(value);
  }

  private getValorCampoExportacao(registro: any, field: string): any {
    switch (field) {
      case 'nome':
        return registro.nome ?? registro.nomeDealer ?? registro.dealer ?? '';
      case 'nomeCliente':
        return registro.nomeCliente ?? '';
      case 'cpfCliente':
        return this.formatarCpfCnpj(registro.cpfCliente);
      case 'telefoneCliente':
        return registro.telefoneCliente ?? '';
      case 'tipoPedido':
        return this.formatTipoPedido(registro.tipoPedido);
      case 'numeroNotaFabrica':
        return registro.numeroNotaFabrica ?? '';
      case 'status':
        return registro.status ?? '';
      case 'dataPedido':
        if (registro.dataPedido && typeof registro.dataPedido === 'object' && typeof registro.dataPedido.toString === 'function') {
          return registro.dataPedido.toString();
        }
        return registro.dataPedido ?? '';
      default:
        return registro[field] ?? '';
    }
  }

  private mapRegistroExportacao(registro: any): Record<string, any> {
    const linha: Record<string, any> = {};

    this.getExportColumns().forEach(col => {
      linha[this.getExportColumnLabel(col)] = this.getValorCampoExportacao(registro, col.field);
    });

    return linha;
  }

  private prepararRegistrosParaExportacao(registros: any[]): any[] {
    return registros.map(registro => {
      const copia = { ...registro };
      this.normalizarDadosCliente(copia);
      return copia;
    });
  }

  private gerarExcel(registros: any[]): void {
    if (!registros?.length) {
      return;
    }

    const linhas = this.prepararRegistrosParaExportacao(registros).map(r => this.mapRegistroExportacao(r));
    this.exportExcelSerivce.nomeModulo = this.nomeModulo;
    this.exportExcelSerivce.ExportTOExcelJSON(linhas);
  }

  public exportExcel() {
    if (this.dados?.length > 0) {
      this.gerarExcel(this.dados);
      return;
    }

    this.service.getDados(this.f.data_inicial.value, this.f.data_final.value, this.f.dealers.value, this.f.grupo_economico.value,
      this.f.chassi.value, this.f.numeroPedidoDealer.value, this.f.numeroPedidoFabrica.value, this.f.status.value, this.f.tipoPedido.value).subscribe(dados => {
        const registros = dados.dealers || [];

        registros.forEach(registro => {
          this.normalizarDadosCliente(registro);

          const atual = this.conversaoLibraConverte.conversaoLibra(registro.valorVenda, null, null);
          const valorFormatado = Intl.NumberFormat('pt-br', { style: 'currency', currency: 'BRL' }).format(atual);
          registro.valorVenda = valorFormatado.replace("R$", "");

          if (registro.dataPedido) {
            const dataStr = typeof registro.dataPedido === 'string'
              ? registro.dataPedido.substring(0, 10)
              : registro.dataPedido;
            registro.dataPedido = moment(new Date(dataStr)).format("DD/MM/YYYY");
          } else {
            registro.dataPedido = " - ";
          }
        });

        this.gerarExcel(registros);
      });
  }

  private changeLanguageValue() {
    this.conversaoLibraConverte.preencher();
    this.subscription = this.translate.onLangChange
      .subscribe((event: LangChangeEvent) => {
        this.loading = true;
        this.preencherTipoPedidoOptions();
        this.getAll();
      });
  }

  private preencherTipoPedidoOptions() {
    this.tipoPedidoOptions = [
      { label: this.translate.instant('relatorioVeiculos.controlePedidos.filtros.tipoPedidoOptions.vendaDireta'), value: 1 },
      { label: this.translate.instant('relatorioVeiculos.controlePedidos.filtros.tipoPedidoOptions.cliente'), value: 2 },
      { label: this.translate.instant('relatorioVeiculos.controlePedidos.filtros.tipoPedidoOptions.estoque'), value: 3 }
    ];
  }

  public saveDados() {
  const chassi = this.dadosCadastro.chassi ? this.dadosCadastro.chassi.trim() : '';
  const numeroPedido = this.dadosCadastro.numeroPedido ? this.dadosCadastro.numeroPedido.trim() : '';

  if (this.validacao(chassi, numeroPedido)) {
    this.submitted = false;

    this.serviceApp.getDados('/veiculo/cadastrarPedidoFabrica?idPedido=' + this.dadosCadastro.idPedido +
      '&numeroPedido=' + numeroPedido + '&chassi=' + chassi)
      .subscribe(dados => {
        this.display = false;
        this.getAll();
      });
  } else {
    this.submitted = true;
  }
}
  public hideDialog() {
    this.submitted = false;
    this.display = false;
    this.dadosCadastro.numeroPedido = '';
    this.dadosCadastro.chassi = '';
  }

  public abrirModal(dados: any) {
    if (this.isCadastroPedidoFabricaBloqueado(dados)) {
      return;
    }

    this.display = true;
    this.dadosCadastro.idPedido = dados.idPedido;
    this.dadosCadastro.numeroPedido = dados.numeroPedido;
    this.dadosCadastro.chassi = dados.chassi;
  }

 validacao(chassi: String, numProposta: String): boolean {
  const chassiTratado = chassi ? chassi.trim() : '';
  const pedidoFabricaTratado = numProposta ? numProposta.trim() : '';
  if (chassiTratado.length > 0 && chassiTratado.length != 17) {
    return false;
  }
  if (pedidoFabricaTratado.length > 0) {
    return true;
  }

  if (chassiTratado.length == 17) {
    return true;
  }

  return true;
}
}